import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';

import { IStoriesSettingsMessages } from '../../../../types';
import { Header } from '../../StoriesPage';

import { styles } from './Header.styles';

export type IHeaderProps = {
  isUpdating: boolean;
  messages: IStoriesSettingsMessages;
  displayPublicationTab: boolean;
  isAdmin: boolean;
  navigateToPublicationList(): any;
  updateSettings(event: React.MouseEvent<HTMLElement>): any;
};

export class StoriesSettingsHeader extends React.Component<IHeaderProps> {
  discardAndGoBack = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    this.props.navigateToPublicationList();
  };

  render() {
    const {
      messages,
      navigateToPublicationList,
      isUpdating,
      displayPublicationTab = false,
      isAdmin
    } = this.props;

    return (
      <Header
        navigateToStoryList={navigateToPublicationList}
        breadcrumbs={[messages.settings]}
        isSettingsPage={true}
        displayPublicationTab={displayPublicationTab}
        isAdmin={isAdmin}
      >
        {isAdmin && isUpdating && <Box component="span" sx={styles.status}>{messages.saving}</Box>}

        {isAdmin && (
          <>
            <Button variant="outlined" color="secondary" size="small" onClick={this.discardAndGoBack} disabled={isUpdating} data-test="back-to-stories">
              {messages.back}
            </Button>
          </>
        )}
      </Header>
    );
  }
}
